var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83.963,
    height: 29.346,
    viewBox: "0 0 83.963033 29.345651",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath878"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1280v1024h-1280z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 -811.35 55.226)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.03 39.908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 29.968,-18.729 59.936,0",
    fill: "none",
    stroke: "#545c63",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath878)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.8 991.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-2.655c-0.033 0.038-0.087 0.07-0.087 0.103 0 2.123-0.279 4.27 0.414 6.341 1.353 4.047 5.333 6.4 9.667 5.743 4.329-0.657 7.355-3.953 7.388-8.345 0.069-9.079 0.022-18.159 0.021-27.239 0-0.086-0.019-0.172-0.036-0.307h-2.74v0.747c0 8.858 2e-3 17.716-1e-3 26.574-1e-3 2.353-0.926 4.217-3.095 5.241-2.288 1.079-4.575 1.028-6.658-0.558-1.467-1.117-2.174-2.661-2.213-4.497-0.026-1.241-5e-3 -2.484-5e-3 -3.803m11.046-23.412c0 9.077 0.016 18.155-0.013 27.232-8e-3 2.459-2.083 4.594-4.512 4.795-2.635 0.219-5.015-1.451-5.453-3.943-0.179-1.015-0.112-2.075-0.143-3.115-0.016-0.52-3e-3 -1.041-3e-3 -1.532h2.789c0 1.296-0.034 2.538 0.01 3.778 0.04 1.133 0.959 1.997 2.121 2.092 1.075 0.087 2.148-0.678 2.371-1.735 0.077-0.364 0.063-0.751 0.063-1.127 4e-3 -8.633 3e-3 -17.267 3e-3 -25.9v-0.864h2.733c0.016 0.148 0.034 0.233 0.034 0.319m7.359-0.322h-2.701c-0.014 0.243-0.039 0.475-0.039 0.707-2e-3 7.568-6e-3 15.136 1e-3 22.704 2e-3 2.834 1.677 4.837 4.363 5.26 2.569 0.404 5.134-1.381 5.643-3.946 0.082-0.41 0.105-0.837 0.111-1.258 0.015-1.104 5e-3 -2.21 5e-3 -3.354h-2.763c0 1.198 0.027 2.369-6e-3 3.538-0.049 1.705-1.635 2.784-3.158 2.163-0.747-0.304-1.234-0.86-1.379-1.666-0.062-0.346-0.074-0.706-0.074-1.059-4e-3 -7.413-3e-3 -14.825-3e-3 -22.238zm2.955-0.873h-16.057v-2.713h16.057zm18.371 26.499v2.734h-7.483v-31.946h2.926v14.966h3.645v2.686h-3.645v11.56zm11.521-24.128v21.777c0 3.214-2.158 5.469-4.748 5.469-2.591 0-4.749-2.255-4.749-5.469v-21.777c0-3.261 2.158-5.468 4.749-5.468 2.59 0 4.748 2.207 4.748 5.468m-2.878-0.575c0-1.104-0.719-1.967-1.87-1.967-1.2 0-1.871 0.863-1.871 1.967v22.928c0 1.055 0.671 1.967 1.871 1.967 1.151 0 1.87-0.912 1.87-1.967zm14.496 0.575v26.862h-2.734v-27.149c0-1.487-0.624-2.255-1.823-2.255-1.151 0-1.775 0.768-1.775 2.255v27.149h-2.878v-26.862c0-3.261 1.967-5.468 4.605-5.468 2.59 0 4.605 2.207 4.605 5.468m12.562-5.084v31.946h-2.734v-21.633l-0.864 4.94-3.645 16.693h-2.83v-31.946h2.734v21.345l0.959-4.844 4.221-16.501zm11.022 29.116v2.83h-8.874v-2.83h3.118v-29.116h2.878v29.116z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1090.8 977.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1090.8 971.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1090.8 964.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
};
export default SvgChevronDown;